/* eslint-disable @typescript-eslint/no-empty-function */
import { ReactElement, useState, createContext } from 'react';
import { AppConfiguration } from '../lib/type';

import { Intro, Profile, Video } from './Modal/Modal';
import SideBar from './SideBar/SideBar';
import { Scenario } from '../data/constants';

import './CloudPakForAiops.scss';

export interface CloudPakForAiopsProps {
  /**
   * All the configuration for the map
   */
  configuration: AppConfiguration;
}
export const layoutContext = createContext({
  currentScenario: '',
  setCurrentScenario: (type: Scenario) => {},
  currentVideo: '',
  setCurrentVideo: (type: string) => {},
  profile: '',
  setProfile: (newProfile: string) => {},
});

const CloudPakForAiops = ({
  configuration,
}: CloudPakForAiopsProps): ReactElement => {
  const [currentScenario, setCurrentScenario] = useState(Scenario.intro);
  const [profile, setProfile] = useState('');
  const [currentVideo, setCurrentVideo] = useState('');

  const getCurrentScenario = () => {
    if (currentScenario === 'intro') {
      return (
        <>
          <Intro copy={configuration.modal} />
        </>
      );
    } else if (currentScenario === 'profile') {
      return (
        <>
          <Profile copy={configuration.modal} />
        </>
      );
    } else if (currentScenario === 'sidebar') {
      return (
        <>
          <SideBar copy={configuration.sidebar} />
        </>
      );
    } else if (currentScenario === 'video') {
      return (
        <>
          <Video />
          <SideBar copy={configuration.sidebar} />
        </>
      );
    }
  };

  return (
    <layoutContext.Provider
      value={{
        currentScenario,
        setCurrentScenario,
        profile,
        setProfile,
        currentVideo,
        setCurrentVideo,
      }}
    >
      <div
        className="cloud-pak-for-aiops_wrapper widget-styles"
        style={{
          background: `linear-gradient(rgba(0, 0, 0, 0.60), rgba(0, 0, 0, 0.60)), url(${process.env.PUBLIC_ASSETS_URL}/cloud-pak-for-aiops/images/welcome-screen-bg.png) no-repeat, black`,
          backgroundSize: 'cover',
          backgroundPosition: 'top left',
        }}
      >
        {getCurrentScenario()}
      </div>
    </layoutContext.Provider>
  );
};

export default CloudPakForAiops;
